
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {AuthService} from '../../services/auth.service';
import {GenericApiResponse, APIResult} from '../apibase.api';
import { HttpClient } from '@angular/common/http';
import {NotificationId, NotificationScope} from "@webmate-web-core/shared/types/ids";

import {DateTime} from '@webmate-web-core/shared/types/base-types';
import {ChannelInfo, Topic, UserNotification} from "@webmate-web-core/shared/types/notification";
import {map} from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class UserNotificationApi {

    constructor (public OAuth2AuthService: AuthService, private http: HttpClient) {}

    addNotification$(scope: NotificationScope, topic: Topic, title: string, text: string): Observable<NotificationId> {
        const notificationBody = {title, text};
        const dto = {scope, notification: notificationBody};
        return this.http.post<NotificationId>(`/notification/${topic}`, dto);
    }

    getNotifications$(channelName: string): Observable<Array<UserNotification>> {
        return this.http.get<APIResult<Array<UserNotification>>>(`/notification/${channelName}`).pipe(map(res => res.data));
    }

    getChannelInfo$(channelName: string): Observable<ChannelInfo> {
        return this.http.get<ChannelInfo>(`/notification/user-channels/${channelName}`);
    }

    markChannelSeen$(channelName: string, seen: DateTime): Observable<GenericApiResponse> {
        return this.http.put<GenericApiResponse>(`/notification/user-channels/${channelName}/seen`, { seen });
    }

    setTopicFilter(channelName: string, topicFilter: Array<Topic>){
        return this.http.put<GenericApiResponse>('/notification/user-channels/'+ channelName +'/set', topicFilter);
    }
}
